/** /vopros-otvet/: category filter, search (button reloads, typing previews), consent checkbox. */
export function initFaq() {
  const list = document.getElementById('questions-list')
  const input = document.getElementById('search-questions') as HTMLInputElement | null
  const loading = document.getElementById('search-loading')
  const filter = document.getElementById('category-filter') as HTMLSelectElement | null

  // The page markup is the same for every category: show the one in the address as selected.
  const cat = new URL(location.href).searchParams.get('cat')
  if (filter && cat && [...filter.options].some((o) => o.value === cat)) filter.value = cat

  filter?.addEventListener('change', (e) => {
    const url = new URL(location.href)
    const cat = (e.target as HTMLSelectElement).value
    if (cat) url.searchParams.set('cat', cat)
    else url.searchParams.delete('cat')
    url.pathname = '/vopros-otvet/'
    location.href = url.toString()
  })
  document.getElementById('search-button')?.addEventListener('click', (e) => {
    e.preventDefault()
    const url = new URL(location.href)
    const q = input?.value.trim()
    if (q) url.searchParams.set('s', q)
    else url.searchParams.delete('s')
    url.pathname = '/vopros-otvet/'
    location.href = url.toString()
  })
  input?.addEventListener('keypress', (e) => {
    if (e.key === 'Enter') document.getElementById('search-button')?.click()
  })

  if (list && input) {
    const original = list.innerHTML
    let timer: number | undefined
    input.addEventListener('input', () => {
      window.clearTimeout(timer)
      timer = window.setTimeout(async () => {
        const q = input.value.trim()
        if (!q) {
          list.innerHTML = original
          if (loading) loading.style.display = 'none'
          return
        }
        if (q.length < 2) return
        if (loading) loading.style.display = 'block'
        try {
          const res = await fetch(`/vopros-otvet/?s=${encodeURIComponent(q)}&partial=faq`)
          list.innerHTML = res.ok ? await res.text() : '<div class="qa-empty">Ошибка при поиске</div>'
        } catch {
          list.innerHTML = '<div class="qa-empty">Ошибка при поиске</div>'
        }
        if (loading) loading.style.display = 'none'
      }, 300)
    })
  }

  document.addEventListener('change', (e) => {
    const t = e.target as HTMLInputElement
    if (t.id === 'my-check') document.getElementById('checkbox-container')?.classList.toggle('is-checked', t.checked)
  })
}
